<script>
  import * as animateScroll from "svelte-scrollto";
  import Spinner from 'svelte-spinner';
  import { ycTicket } from './stores';
  import { readable, derived } from 'svelte/store';
  import Axios from "axios";

  export let venueName = "The Arena";
  export let leagueCode = "yc";
  export let teamCode = "test";
  export let teamCity = "CityName";
  export let teamMascot = "SportsTeam";
  export let colorPrimary = "#000000";
  export let colorSecondary = "#ffffff";
  export let isAnonymous = false;
  export let questions = [];
  export let allowChildren = true;
  export let childPluralNoun = "Children";
	export let childSingularNoun = "Child";
	export let childPluralPossessive = "Children's";
  export let childQuestionText = `Are there any ${childPluralNoun.toLowerCase()} accompanied by you for the scheduled event?`;
  export let childNamesPrompt = `${childPluralPossessive} NAMES`.toUpperCase();
  export let childAddButtonLabel = `Add ${childSingularNoun}`;
  export let childAddInputPlaceholder = `${childSingularNoun} Name Here`;
  export let fieldPrefix = 'covid_screening';
  export let showTicketsButton = true;
  export let iOSTicketsUrl = `yc-${leagueCode}-${teamCode}://action/ALERT?title=iOS%20Tickets&description=This%20is%20a%20test%20link%20to%20tickets%20on%20iOS%21&cancelButtonTitle=OK`;
  export let androidTicketsUrl = `yc-${leagueCode}-${teamCode}://action/ALERT?title=Android%20Tickets&description=This%20is%20a%20test%20link%20to%20tickets%20on%20Android%21&cancelButtonTitle=OK`;
  export let eventIdOverride = null;
  export let welcomeMessageOverride = null;

  const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
  const dtf = new Intl.DateTimeFormat('en-US', options);
  const v1v2 = (['nfl', 'nhl', 'venue'].includes(leagueCode))? 'V2' : 'V1';
  const hostSuffix = (leagueCode === 'venue')? `${teamCode}-venues` : `${teamCode}-${leagueCode}`;
  const appId = `${leagueCode.toUpperCase()}_${teamCode.toUpperCase()}`;

  const ycGameBox = readable(null, async (set) => {
    if (eventIdOverride != null) {
      set({ Id: eventIdOverride });
      return;
    }
    const rsp = await Axios.request({
      method: 'get',
      url: `https://app-${hostSuffix}.yinzcam.com/${v1v2}/Game/Box?application=${appId}&version=20.0&os=iOS`,
      headers: { 'Accept': 'application/json' }
    });
    const data = rsp.data;
    // TODO: Check response
    console.log('game box loaded');
    set(data);
  });

  const fieldNames = derived(ycGameBox, ($ycGameBox, set) => {
    if ($ycGameBox?.Id == null)
      return;
    set({
      timestamp: `${fieldPrefix}_${$ycGameBox.Id}_timestamp`,
      passed: `${fieldPrefix}_${$ycGameBox.Id}_passed`,
      children: `${fieldPrefix}_${$ycGameBox.Id}_children`,
    });
  }, null);

  const ycProfile = derived([fieldNames, ycTicket], async ([$fieldNames, $ycTicket], set) => {
    if (isAnonymous || !$fieldNames || !$ycTicket?.ticket)
      return;
    console.log(`doing profile query for ${$fieldNames.passed}`);
    const rsp = await Axios.request({
      method: 'post',
      url: `https://signon-${hostSuffix}.yinzcam.com/profile2/user/combined/query`,
      headers: { 'Accept': 'application/json', 'X-YinzCam-AppID': appId, 'X-YinzCam-Ticket': $ycTicket.ticket },
      data: {
        Field: [ $fieldNames.timestamp, $fieldNames.passed, $fieldNames.children, 'first_name', 'last_name' ]
      }
    });
    const data = rsp.data;
    var profile = { };
    for (var i = 0; i < data.Entry.length; i++) {
      var entry = data.Entry[i];
      profile[entry.Key] =  entry.Value;
    }
    console.log('profile loaded');
    set(profile);
  }, null);

  let name = "";
  let hasChildren = false;
  let children = [];
  let childCount = 0;
  let firstLoad = true;
  let loading = true;
  let submitted = false;
  let passed = true;

  // only count children that have names and only before the form is submitted
  $: if (!submitted) {
    childCount = children.filter((c) => c).length;
  }

  // update name when our profile changes
  $: if (!isAnonymous && $ycProfile?.first_name && $ycProfile?.last_name) {
    name = `${$ycProfile.first_name} ${$ycProfile.last_name}`;
  }

  $: if (firstLoad && (isAnonymous || ($fieldNames && $ycProfile))) {
    firstLoad = false;
    loading = false;
    if ($ycProfile?.hasOwnProperty($fieldNames.passed)) {
      passed = $ycProfile[$fieldNames.passed] === 'true';
      submitted = true;
    }
    if ($ycProfile?.hasOwnProperty($fieldNames.children)) {
      childCount = parseInt($ycProfile[$fieldNames.children]);
      if (isNaN(childCount))
        childCount = 0;
      hasChildren = childCount > 0;
    }
  }

  let logoUrl;
  $: switch (leagueCode) {
    case 'nba':
      logoUrl = `https://resources-us.yinzcam.com/nba/shared/logos/nba_${teamCode}_dark.png`;
      break;
    case 'nfl':
    default:
      logoUrl = `https://resources-us.yinzcam.com/${leagueCode}/logos/${leagueCode}_${teamCode}_dark.png`;
      break;
  }

  function optionClick(i, j) {
    //console.log(`${i}, ${j}`);
    let q = questions[i];
    let o = q.options[j];

    o.selected = !o.selected;

    if (!q.selectionCount)
      q.selectionCount = 0;
    
    q.selectionCount += (o.selected)? 1 : -1;
    if (q.maxSelections && q.selectionCount > q.maxSelections) {
      if (q.maxSelections == 1) {
        // unselect all of the other ones
        for (const [ k, o2 ] of q.options.entries()) {
          if (k != j) {
            o2.selected = false;
          }
        }
      } else {
        // disallow this selection
        o.selected = false;
        q.selectionCount--;
      }
    }
    //assert(q.selectionCount <= q.maxSelections);

    questions = questions;
  }

  function submitClick() {
    let valid = true;
    for (const q of questions) {
      let answered = false;
      q.error = null;
      for (const o of q.options) {
        passed = passed && (!o.selected || o.selected && o.allowed);
        answered = answered || o.selected;
      }
      if (q.required && !answered) {
        q.error = "This question is required.";
        valid = false;
      }
    }
    questions = questions;
    if (!valid) {
      submitted = false;
      animateScroll.scrollTo({element: '#name-entry-card'});
      return;
    }

    // anonymous forms skip the submission step
    if (isAnonymous) {
      submitted = true;
      animateScroll.scrollToTop();
      return;
    }

    loading = true;
    let now = new Date().toISOString();
    Axios.request({
      method: 'post',
      url: `https://signon-${hostSuffix}.yinzcam.com/profile2/user/segments/USER`,
      headers: { 'Accept': 'application/json', 'X-YinzCam-AppID': appId, 'X-YinzCam-Ticket': $ycTicket.ticket },
      data: {
        Entry: [{
          Key: $fieldNames.timestamp,
          Value: now,
          Values: [{
            Value: now
          }]
        },{
          Key: $fieldNames.passed,
          Value: passed,
          Values: [{
            Value: passed
          }]
        },{
          Key: $fieldNames.children,
          Value: childCount,
          Values: [{
            Value: childCount
          }]
        }]
      }
    }).then(function (response) {
      console.log('profile updated');
      loading = false;
      submitted = true;
      animateScroll.scrollToTop();
    });
  }

  function ticketsClick() {
    if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
      window.location.href = iOSTicketsUrl;
    } else if (typeof window.YinzNativeApplication != 'undefined') {
      window.location.href = androidTicketsUrl;
    } else {
      console.log('tickets click dropped, unsupported platform');
    }
  }
</script>

<style>
  .bg-pass {
    background-image: url("../images/screening_pass_bg.gif");
    background-repeat: round;
    background-size: 100% auto;
  }
  .bg-fail {
    background-image: url("../images/screening_fail_bg.gif");
    background-repeat: round;
    background-size: 100% auto;
  }
  .overlay {
    position: fixed; /* Sit on top of the page content */
    display: block; /* Hidden by default */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 3;
  }
  ::placeholder {
    color: gray;
    opacity: 0.75;
  }
</style>

{#if loading}
<div class="overlay">
</div>
<div class="spinner">
  <Spinner size="4rem" color="rgba(255,255,255,0.8)" />
</div>
{/if}

{#if submitted}
<main class="font-medium text-gray-600 text-center px-4 pb-12 mx-auto my-0" 
  class:bg-pass={passed} class:bg-fail={!passed}
  style="--color-primary: {colorPrimary}; --color-secondary: {colorSecondary};">
  <div class="flex flex-col items-center justify-center min-h-screen space-y-3">
    <div>
      <img class="max-h-36" alt="{teamCity} {teamMascot} Logo" src={logoUrl}>
    </div>
    <div>
      <img class="w-full" alt="" src={`images/screening_${(passed)? "pass" : "fail"}.svg`}>
    </div>
    <div class="text-4xl text-white">
      <br>
      {(passed)? "Passed" : "Failed"} Screening
    </div>
    <div class="text-white">
      Have this screen ready to show at the gates.<br>
    </div>
    <div class="text-white text-xl">
      {#if hasChildren && childCount > 0}
        +{childCount} {(childCount == 1)? childSingularNoun : childPluralNoun}
      {/if}
      <br>
    </div>
    {#if showTicketsButton}
    <div class="w-1/2">
      <button class="w-full border border-white rounded-md py-4 text-white" type="button" on:click={ticketsClick}>View Tickets</button>
    </div>
    {/if}
  </div>
</main>
{:else}
<main class="bg-gray-100 font-medium text-gray-600 text-center px-4 pb-12 mx-auto my-0" style="--color-primary: {colorPrimary}; --color-secondary: {colorSecondary};">
  <div class="flex flex-col items-center justify-center min-h-screen space-y-3">
    <div>
      <img class="max-h-48" alt="{teamCity} {teamMascot} Logo" src={logoUrl}>
    </div>
    <div>
      {#if welcomeMessageOverride}
        {@html welcomeMessageOverride}
      {:else}
        Welcome to {venueName}. The safety of {leagueCode.toUpperCase()} fans is our highest priority.
        To prevent the spread of COVID-19 and reduce the risk of exposure to other fans,
        we are conducting a simple screening questionnaire. Your participation is important
        to take the proper precautionary measures to help protect everyone in {venueName}.
      {/if}
      <br><br>
    </div>
    <div id="name-entry-card" class="w-full space-y-2">
      <div class="text-left font-bold pl-3">
        COVID-19 SCREENING FORM
      </div>
      <div class="bg-white border border-gray-300 rounded-md shadow-lg p-4 flex flex-row justify-between">
        <div class="text-left text-gray-600">
          Full Name
        </div>
        <div class="text-gray-800">
          <input class="w-full text-right" type="text" placeholder="Your Name Here" bind:value={name}>
        </div>
      </div>
      <div class="text-gray-600 text-center text-sm">
        Signed: {dtf.format(new Date())}
      </div>
    </div>
    {#each questions as question, i}
    <div class="w-full bg-white rounded-md shadow-lg p-4 space-y-4">
      <div class="text-left">
        {@html question.text}
      </div>
      {#if question.error}
      <div class="text-left text-red-500 italic">
        {question.error}
      </div>
      {/if}
      {#if question.options.length < 3}
      <div class="w-full flex space-x-6">
        {#each question.options as option, j}
        <button class="flex-1 border border-gray-300 rounded-md py-4"
          class:text-gray-600={!option.selected}
          class:bg-primary={option.selected}
          class:text-white={option.selected}
          type="button" on:click={optionClick.bind(null, i, j)}>{option.text}</button>
        {/each}
      </div>
      {:else}
      <div class="w-full grid grid-cols-2 gap-3">
        {#each question.options as option, j}
        <button class="border border-gray-300 rounded-md p-2"
          class:text-gray-600={!option.selected}
          class:bg-primary={option.selected}
          class:text-white={option.selected}
          type="button" on:click={optionClick.bind(null, i, j)}>{option.text}</button>
        {/each}
      </div>
      {/if}
    </div>
    {/each}
    {#if allowChildren}
    <div class="w-full bg-white rounded-md shadow-lg p-4 space-y-4">
      <div class="text-left">
        {@html childQuestionText}
      </div>
      <div class="w-full flex space-x-6">
        <button class="flex-1 border border-gray-300 rounded-md py-4"
          class:text-gray-600={hasChildren}
          class:bg-primary={!hasChildren}
          class:text-white={!hasChildren}
          type="button" on:click={() => hasChildren = false }>No</button>
          <button class="flex-1 border border-gray-300 rounded-md py-4"
          class:text-gray-600={!hasChildren}
          class:bg-primary={hasChildren}
          class:text-white={hasChildren}
          type="button" on:click={() => hasChildren = true }>Yes</button>
      </div>
    </div>
    {#if hasChildren}
      <div class="w-full space-y-2">
        <div class="text-left font-bold pl-3">
          {childNamesPrompt}
        </div>
        {#each children as child, i}
        <div class="bg-white border border-gray-300 rounded-md shadow-lg p-4 flex flex-row justify-between">
          <div class="text-left text-gray-600">
            Full Name
          </div>
          <div class="text-gray-800">
            <input class="w-full text-right" type="text" placeholder="{childAddInputPlaceholder}" bind:value={children[i]}>
          </div>
        </div>
        {/each}
        <div class="bg-white border border-gray-300 rounded-md shadow-lg p-4 flex flex-row justify-between items-center" on:click={() => children = [...children, null] }>
          <div class="text-left text-gray-600">
            {childAddButtonLabel}
          </div>
          <div class="text-gray-800 text-right">
            <img alt="" src="images/icon_add_children.svg">
          </div>
        </div>
      </div>
    {/if}
    {/if}
    <div class="w-3/4">
      <br>
      Thank you for participating in the COVID-19 Screening Form. Any unsupported answers will result in denial of entry into {venueName}.
    </div>
    <div class="w-1/2">
      <button class="w-full border border-gray-300 rounded-md py-4 bg-primary text-white" type="button" on:click={submitClick}>SUBMIT</button>
    </div>
    {#if showTicketsButton}
    <div class="w-1/2">
      <button class="w-full border border-gray-300 rounded-md py-4 text-gray-600" type="button" on:click={ticketsClick}>View Tickets</button>
    </div>
    {/if}
  </div>
</main>
{/if}